/**
 * The query parameter that carries a saved booking intent through sign-in (OAuth `state`, the
 * post-auth landing, and the protected-route login redirect). Lives here rather than in
 * `booking-service.js` so the boot-chunk auth code can build the redirect without pulling the
 * booking service into every pageview (TENANT-5036).
 */
export const BOOKING_INTENT_QUERY_PARAM = 'booking_intent_token'

/**
 * The protected-route sign-in redirect: the home page opens the auth modal for `login=true`,
 * returning to `from` — or, with a booking intent, resuming that intent after sign-in (TENANT-5504).
 *
 * @param {{ from: string, bookingIntentToken?: string }} target
 * @returns {string} a root-relative path.
 */
export const buildSignInRedirectPath = ({
    bookingIntentToken,
    from,
}) => {
    if (typeof from !== 'string' || !from.startsWith('/')) {
        throw new TypeError('buildSignInRedirectPath requires a root-relative `from` path.')
    }
    const intentParameter = bookingIntentToken
        ? `&${BOOKING_INTENT_QUERY_PARAM}=${encodeURIComponent(bookingIntentToken)}`
        : ''
    return `/?login=true&from=${encodeURIComponent(from)}${intentParameter}`
}
